import { useRevalidator } from '@remix-run/react';

import { NectarPageBlock } from '~/utils/nectarPageBlock';
import { withNectarTrackingParams } from '~/utils/nectarTracking';

import { useCommunityActionBase } from './useCommunityActionBase';

const UPDATE_CURRENT_MEMBER_ACTION = '/update_community_current_member';

// Revalidates on success so the refreshed currentMember hides the callout everywhere it reads
// membership.
export const useDismissMobileAppCalloutMutation = () => {
  const revalidator = useRevalidator();

  return useCommunityActionBase<void>({
    buildRequest: () => ({
      path: UPDATE_CURRENT_MEMBER_ACTION,
      fields: withNectarTrackingParams(
        { mobile_app_callout_dismissed: 'true' },
        NectarPageBlock.CommunityMobileAppCallout,
      ),
    }),
    onSuccess: () => revalidator.revalidate(),
  });
};
